import { API_ROUTES } from '@/constants/apiRoutes';
import { ApiResponse, PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import {
  AdminPlanDetailResponse,
  ClubPlanDetailResponse,
  GetTimeIntervalParams,
  TimeIntervalList,
} from '../premiumStores/premiumStores.types';
import {
  GetAdminPlanDetailParams,
  GetClubPlanDetailParams,
  PlanManagement,
  PlanManagementParams,
} from './planManagement.types';

export const getPlanList = (client: AxiosInstance) => async (params?: PlanManagementParams) => {
  return (await client.get<PaginatedApiResponse<PlanManagement[]>>(API_ROUTES.GET_CLUB_PLAN_LIST, { params })).data;
};
export const getTimeInterval = (client: AxiosInstance) => async (params: GetTimeIntervalParams) => {
  return (await client.get<ApiResponse<TimeIntervalList>>(API_ROUTES.GET_TIME_INTERVAL, { params })).data;
};

export const getClubPlanDetail = (client: AxiosInstance) => async (params: GetClubPlanDetailParams) => {
  return (await client.get<ApiResponse<ClubPlanDetailResponse>>(API_ROUTES.GET_CLUB_PLAN_DETAIL, { params })).data;
};

export const getAdminPlanDetail = (client: AxiosInstance) => async (params: GetAdminPlanDetailParams) => {
  return (await client.get<ApiResponse<AdminPlanDetailResponse>>(API_ROUTES.GET_ADMIN_PLAN_DETAIL, { params })).data;
};

export const planManagementQueries = {
  all: () => ['planList'],
  list: (params?: PlanManagementParams) =>
    queryFactoryOptions<PaginatedApiResponse<PlanManagement[]>>({
      queryKey: [...planManagementQueries.all(), 'list', params],
      queryFn: (client: AxiosInstance) => () => getPlanList(client)(params),
    }),
  detail: (params: GetClubPlanDetailParams) =>
    queryFactoryOptions<ApiResponse<ClubPlanDetailResponse>>({
      queryKey: [...planManagementQueries.all(), 'detail', params],
      queryFn: (client: AxiosInstance) => () => getClubPlanDetail(client)(params),
    }),
  adminPlanDetail: (params: GetAdminPlanDetailParams) =>
    queryFactoryOptions<ApiResponse<AdminPlanDetailResponse>>({
      queryKey: [...planManagementQueries.all(), 'detail', params],
      queryFn: (client: AxiosInstance) => () => getAdminPlanDetail(client)(params),
    }),
  timeInterval: (params: GetTimeIntervalParams) =>
    queryFactoryOptions<ApiResponse<TimeIntervalList>>({
      queryKey: ['timeInterval'],
      queryFn: (client: AxiosInstance) => () => getTimeInterval(client)(params),
    }),
};
